import React from 'react'

export default function Stakeholders() {
  return (
    <section className='mt-5 mb-5'>
        <div className='container'>
            <div className='row'>
                <div className='col-12'>

                <div className='mb-3 '>
                        <h4 className='font-italic d-inline p-1 bg-warning'>Stakeholders</h4><br></br>
                    </div>



                    <div>
                        <p>Invasive species spread through private and public land and from commercial and private enterprises, therefore developing partnerships is critical to the success of invasive species management programs. The benefits of partnerships for invasive species management include the sharing of knowledge, experience and resources, as well as encouraging coordination of activities to achieve more effective outcomes. Helping people to understand the key invasive species issues, involving people in invasive species control using the most effective techniques and focusing efforts and energy in the right direction is critical to effective invasive species management.
                        </p>

                        <p>This NISSAP was prepared for the Ministry of Health, Wellness and the Environment of Antigua and Barbuda, with the Department of Environment charged with the responsibility of oversight, to assist with the planning and development of the NISSAP. Development of the NISSAP is one of the key outputs under the UNEP-GEF/ CABI executed regional IAS project.  
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}